export const parseDecimal = (value: string): number | "" => {
  const normalized = value.replace(",", ".");
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? "" : parsed;
};
